import moment from 'moment'

export const DEFAULT_ERROR = {
  pet_id: 'Selecione um pet para o agendamento',
  service_id: 'Selecione um serviço',
  locations: 'Informe sua localização',
  professional_id: 'Selecione um profissional para o atendimento',
  selectDay: 'Selecione um dia para agendamento',
  partner_id: 'Selecione um parceiro',
  selectTime: 'Selecione um horário para atendimento',
  address: 'Informe o endereço',
  unavailabilityPets: []
}

export const INITIAL_SCHEDULE_BODY = {
  pet_id: undefined,
  service_id: undefined,
  additional_services: [],
  locations: undefined,
  professional_id: '',
  partner_id: undefined,
  selectDay: undefined,
  selectTime: undefined,
  samePetDate: undefined,
  isServicePackage: false,
  purchasedPackageId: undefined,
  isSchedulingFromPackage: false
}

export const INITIAL_ACTIVE_STEP = 1

export const now = moment()

export const INITIAL_CALENDAR_DATE = {
  calendarMonth: now.month() + 1,
  calendarYear: now.year()
}

export const SCHEDULING_STATUSES = {
  SCHEDULED: { message: 'Serviço agendado', role: 'warning', active: true, shortMessage: 'Agendado' },
  IN_PROGRESS: { message: 'Serviço em andamento', role: 'info', active: true, shortMessage: 'Em andamento' },
  FINISHED: { message: 'Serviço realizado', role: 'success', active: false, shortMessage: 'Realizado' },
  CANCELLED: { message: 'Serviço cancelado', role: 'error', active: false, shortMessage: 'Cancelado' },
  DESIST: { message: 'Serviço cancelado', role: 'error', active: false, shortMessage: 'Cancelado' },
  NO_SHOW: { message: 'Serviço cancelado', role: 'error', active: false, shortMessage: 'Cancelado' },
  PAYMENT_PENDING: { message: 'Serviço aguardando pagamento', role: 'info', active: false, shortMessage: 'Agendado' }
}

export const PACKAGE_STATUSES = {
  ACTIVE: { message: 'Ativo', role: 'success', active: true, rescheduleSchedulingEnabled: true },
  CANCELLED: { message: 'Cancelado', role: 'error', active: false, rescheduleSchedulingEnabled: false },
  UNDER_REVIEW: { message: 'Em análise', role: 'pending', active: true, rescheduleSchedulingEnabled: false },
  EXPIRED: { message: 'Expirado', role: 'disabled', active: false, rescheduleSchedulingEnabled: false },
  FINISHED: { message: 'Finalizado', role: 'finished', active: false, rescheduleSchedulingEnabled: true }
}

export const INITIAL_SCHEDULING_STATE = {
  professionalAlreadySelected: false,
  scheduleBody: INITIAL_SCHEDULE_BODY,
  formList: [],
  partnersData: [],
  totalPartners: undefined,
  serviceData: [],
  additionalServiceData: [],
  professionalData: [],
  pricesData: [],
  serviceDurations: {},
  petsData: [],
  timeData: [],
  availableDates: [],
  error: {
    ...DEFAULT_ERROR
  },
  address: undefined,
  haveError: false,
  selectedPet: {},
  modal: undefined,
  professionalProfile: undefined,
  calendarMonth: INITIAL_CALENDAR_DATE.calendarMonth,
  calendarYear: INITIAL_CALENDAR_DATE.calendarYear,
  usingGeolocation: false,
  obs: '',
  isCustomAddress: false,
  customAddressType: undefined,
  cep: undefined,
  storeName: undefined,
  schedulingData: {},
  havePayment: false,
  selectedPetSchedule: undefined,
  productCoupon: undefined,
  activeCampaign: undefined,
  campaigns: undefined,
  isAllAdditionalServicesSelected: false,
  activeStep: INITIAL_ACTIVE_STEP,
  noPreference: false,
  review: false,
  isHowToPay: false,
  paymentType: undefined,
  schedulingItemError: undefined,
  expanded: false,
  rescheduleDataLoaded: false,
  changeStore: false,
  disableStickyItems: false,
  invertStep: undefined,
  updatedProfessionals: false,
  schedulingCoupon: undefined,
  bestDiscount: undefined,
  useTerms: false,
  packageUseTerms: false
}

export const SCHEDULING_ERROR_MESSAGES = {
  coupon_limit_reached: 'Cupom esgotado'
}

export const SCHEDULING_STEPS = {
  PET_AND_SERVICE: 1,
  PARTNER: 2,
  FLOW_SELECTION: 3,
  PROFESSIONAL: 4,
  DATE_AND_TIME: 5,
  REVIEW: 6,
  HOW_TO_PAY: 7
}

export const SERVICE_PACKAGE_STEPS = {
  PET_AND_SERVICE: 1,
  PARTNER: 2,
  PROFESSIONAL: 3,
  PAYMENT_ADDRESS: 4,
  HOW_TO_PAY: 5
}

export const PURCHASED_PACKAGE_SCHEDULING_STEPS = {
  PET_AND_SERVICE: 1,
  DATE_AND_TIME: 2,
  REVIEW: 3,
  HOW_TO_PAY: 4
}
